<template>
    <div id="frontdefaultdiv">
        <div class="alert">
            <badgealert/>
        </div>

        <div class="student" v-if="hasBadgePerson">
            <div >
                <div class="images" v-if="hasImagePerson">
                    <div class="imgvert">
                        <div>
                            <img src="@/assets/dl.jpg" :class="licenseClass" @click="$refs.mymodal.openModal()" >
                        </div>
                        <div>
                            <label class="smalltext logolabel" v-if="BadgeDesign.showLicenseIcon">Driver's License</label>
                        </div>
                        
                    </div>

                    <div :class="personImageClass" >
                        <div >
                            <p v-if="showActive && showActiveBlinking" class="activetextclass">Active</p>
                            <p v-if="showInactive && showActiveBlinking" class="inactivetextclass">Inactive</p>
                            
                            <img :src="imagePathPerson" class="studentimage activeperson"   v-if="capturedPersonURL==null && showActive && showActiveBlinking" @click="startselfie()" />
                            <img :src="imagePathPerson" class="studentimage inactiveperson"   v-if="capturedPersonURL==null && showInactive && showActiveBlinking" @click="startselfie()" />
                            <img :src="imagePathPerson" class="studentimage"   v-if="capturedPersonURL==null && !showActiveBlinking" @click="startselfie()" />
                        </div>
                        
                        <img alt="selfie image"  :src="capturedPersonURL" class="studentimage" v-if="capturedPersonURL!=null" @click="startselfie()" />
                    </div>
                    
                    <div class="imgvert">
                        <!-- <img src="@/assets/vac2.png" :class="vaccineClass" @click="$refs.vaccine.openModal()" >
                        <label class="smalltext logolabel" v-if="BadgeDesign.showVaccineCardIcon">Vaccine</label> -->
                    </div>
                    
                </div>
                <!-- GET PIC  -->
                <smallbutton toplabel="Update Photo" @click="startselfie()" v-if="allowCapturePerson"/>
                <imageall ref="imgselfie" :allowFileSelect="allowFileSelect" :allowFileSelectIfNoCapture='allowFileSelectIfNoCapture' @saveimg="saveimg_selfie"  :showImage='showImagesInCapture' v-if="allowCapturePerson" />


                <div class="horixFlex studentinfo" >

                    <label class="studentname">{{badgeData.person.firstName}}</label>
                    <label class="studentname">{{badgeData.person.lastName}}</label>
                    
                
                </div>
                <div class="vertFlex">
                    <label for="" class="studentclass" v-if="badgeData.person.personRoleName!=null" >{{badgeData.person.personRoleName}}</label>
                    <label for="" class="studentclass" v-if="badgeData.person.programName!=null" >{{badgeData.person.programName}}</label>
                    <label for="" class="studentclass" v-if="badgeData.person.className!=null && showClass" >{{badgeData.person.className}}</label>
                </div>
                
            </div>
        </div>

        <div :class="statusdivClass" v-if="showStatus">
            <label class="statustext">{{badgeData.person.personStatusName}} </label>
        </div>
        <div class="status statusdivnegative" v-if="showInactive && !showActiveBlinking">
            <label class="statustext">INACTIVE</label>
        </div>
        <div class="barcode" v-if="hasBadgePerson && badgeData.person.code!=null && showBarcode ">
            <div v-if="barcodeType!='QR'">
                <barcode :value="badgeData.person.code" height="40px" :format="barcodeType"></barcode>
            </div>
            <div v-if="barcodeType=='QR'">
                <qrcode-vue :value="badgeData.person.code" size="80" level="H"/>
            </div>
            <div v-if="!showBarcode">
                <label class="studentnumber">{{badgeData.person.code}} </label>
            </div>
            
        </div>

        <!-- drivers license -->
        <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <div >
                <div class="rightjustified">
                    <smallbutton @click="$refs.mymodal.closeModal()" toplabel='X' buttonclass="buttonclose" />
                </div>
                <label class="studentname">Driver's License</label>
                <div :class="licenseFrontClass" @click="startlicensefront()">
                    <img :src="imagePathLicenseFront" class="popuppic"   v-if="capturedLicenseFrontURL==null" />
                </div>
                <img alt="dl image"  :src="capturedLicenseFrontURL" class="popuppic" v-if="capturedLicenseFrontURL!=null"/> 

               <!-- GET PIC  -->
                <smallbutton toplabel="Update Front" @click="startlicensefront()" v-if="allowCaptureLicenseFront"/>
                <imageall ref="imgfront" captureText="Take Photo of Front"  :allowFileSelect="allowFileSelect" :allowFileSelectIfNoCapture='allowFileSelectIfNoCapture' @saveimg="saveimg_LicenseFront"  :showImage='showImagesInCapture' v-if="allowCaptureLicenseFront"/>


                <div :class="licenseBackClass" @click="startlicenseback()">
                    <img :src="imagePathLicenseBack" class="popuppic"   v-if="capturedLicenseBackURL==null && showLicenseBackImage" />
                </div>
                <img alt="dl image"  :src="capturedLicenseBackURL" class="popuppic" v-if="capturedLicenseBackURL!=null"/> 
 
                <!-- GET PIC  -->
                <smallbutton toplabel="Update Back" @click="startlicenseback()" v-if="allowCaptureLicenseBack"/>
                <imageall ref="imgback" captureText="Take Photo of Back"  :allowFileSelect="allowFileSelect" :allowFileSelectIfNoCapture='allowFileSelectIfNoCapture' @saveimg="saveimg_LicenseBack"  :showImage='showImagesInCapture' v-if="allowCaptureLicenseBack"/>

                <!-- <smallbutton @click="$refs.mymodal.closeModal()" toplabel='Close' buttonclass="button buttonhighlight" /> -->
            </div>
        </template>
      </actionmodal>
    </div>
  </template>
  
  <script>
  import smallbutton from '../controls/button.vue'
  import linkbutton from '../controls/linkbutton.vue'
  import {mapFields} from 'vuex-map-fields'
  import badge from '../../services/badge.js'
  import style from '../../style.js'
  import VueBarcode from 'vue-barcode'
  import imageall from '../controls/ImageAll.vue'
import badgealert from '../badgealert.vue'
import actionmodal from '../controls/actionmodal.vue'
  export default {
      components:{
        'barcode':VueBarcode,
          smallbutton,
          linkbutton,
          imageall,
          badgealert,
          actionmodal
      },
      name:"front_default",
      mixins:[style, badge],
      props:{
           
      },
      data(){
          return{
              
          }
      },
      computed:{
        ...mapFields([
            'badgeData',
            'imageBasePath',
            'BadgeDesign',
        ]),
      },
      methods:{
        startselfie(){
            this.$refs.imgselfie.openModal()
        },
        startlicenseback(){
            this.$refs.imgback.openModal()
        },
        startlicensefront(){
            this.$refs.imgfront.openModal()
        },
        startvaccine(){
            this.$refs.imgvac.openModal()
        },
      }
  }
  </script>
  
  <style>

  </style>



